enum EnvironmentEnum {
  DEVELOPMENT = 'development',
  DEV = 'dev',
  QA = 'qa',
  STAGE = 'stage',
  STAGERX = 'stage_rx',
  PROD = 'prod',
  PRODRX = 'prod_rx',
  PR = 'pr',
}

type EnvironmentEnumType = `${EnvironmentEnum}`;

export const envSwitch = (envOptions: Record<EnvironmentEnum, string>, overrideEnv?: EnvironmentEnumType): string => (
  envOptions[overrideEnv ?? process.env.REACT_APP_DEPLOY_ENV as EnvironmentEnum]
);

export const baseURL = process.env.PUBLIC_URL;
